function Projects() {
  return (
    <>
      <h2 className="main-title financing-h2" style={{ textAlign: "center" }}>
        PROJEKTY UE
      </h2>
      <div className="text-center" align="center">
        <img alt="financing" src="/img/logotypes_2021_2027.png" className="img-fluid" />
      </div>
      <h2 className=".main-p financing-h2" style={{ textAlign: "center" }}>
        INNOWACJA
      </h2>
      <div className="container financing">
        <div className="container">
          <div className="container col-md-12" style={{ textAlign: "justify" }}>
            <p>
              Firma <strong>MP-Tech Piotr Mętel</strong> z siedzibą w Suwałkach informuje, iż w dniu 23.04.2024 r.
              zawarła Umowę pożyczki na innowacje nr 2/FEPD/4723/2024/I/EFRR/007/120. Niniejsza pożyczka została
              sfinansowana ze środków pochodzących z Funduszu Pożyczkowego utworzonego między innymi ze środków Programu
              Fundusze Europejskie dla Podlaskiego 2021-2027 oraz ze środków stanowiących krajowe współfinansowanie,
              zgodnie z Umową nr FEPD.PFP-IZ.00-0001/23-00 o finansowaniu Projektu pn. „Instrumenty Finansowe dla
              Podlaskiego 2021-2027” w ramach Fundusze Europejskie dla Podlaskiego 2021-2027, Priorytetu FEPD.01 Badania
              i Innowacje, Działania FEPD.01.06 Wsparcie zwrotne na innowacje (nr FEPD.01.06-IZ.00-0001/23-00) <br />
              <strong>Opis i zadania projektu:</strong> Nadrzędnym celem projektu jest podniesienie oraz wzmocnienie
              trwałego wzrostu konkurencyjności firmy na rynku poprzez wdrożenie innowacji w zakresie działalności
              usługowej z ukierunkowaniem na zwiększenie zaawansowania technologicznego przedsiębiorstwa poprzez zakup
              zestawu innowacyjnych maszyn i urządzeń budowlanych w postaci: spycharki, koparki gąsiennicowej, koparki
              kołowej i walca drogowego oraz sfinansowanie kapitału obrotowego związanego z inwestycją. Urządzenia te
              mają bardzo szerokie zastosowanie i wykorzystywane będą przy prowadzonych robotach ziemnych i drogowych. Z
              projektu korzystać będą pracownicy, uczestniczący w procesach świadczenia usług w/w zestawem maszyn i
              urządzeń budowlanych oraz osoby zarządzające świadczeniem usług w naszej firmie, a docelowo, z tak
              wypracowanych rozwiązań technologicznych skorzystają wszyscy klienci spółki. Efektem projektu będzie
              realizacja różnego rodzaju budowlanych prac ziemnych przy wykorzystaniu w/w sprzętu wysokiej wydajności i
              precyzji. Usługi wykonywane za pomocą tego zestawu maszyn i urządzeń budowlanych to inwestycja o
              charakterze innowacyjnym, która przyniesie szereg korzyści w postaci zwiększenia wydajności, oszczędności
              czasu i kosztów, poprawy jakości wykonywanych prac ziemnych oraz bezpieczeństwa i komfortu pracy. Powyższy
              zakup udoskonali proces świadczenia usług przez firmę MP-TECH Piotr Mętel, a zakupiona: spycharka, koparka
              gąsiennicowa, koparka kołowa i walec drogowy wprowadzą innowacyjny, polepszony sposób świadczenia usług{" "}
              <br />
              <strong>#FunduszeEuropejskie</strong>
              <br />
              <br />
              Wartość projektu: <strong>940 000,00 PLN</strong> <br />
              Wysokość wkładu z Funduszy Europejskich: <strong>232 618,19 PLN</strong>
            </p>
          </div>
        </div>
      </div>

      <h2 className=".main-p financing-h2" style={{ textAlign: "center" }}>
        CYFRYZACJA
      </h2>
      <div className="container financing">
        <div className="container">
          <div className="container col-md-12" style={{ textAlign: "justify" }}>
            <p>
              Firma <strong>MP-Tech Piotr Mętel</strong> z siedzibą w Suwałkach informuje, iż w dniu 23.04.2024 r.
              zawarła Umowę pożyczki na cyfryzację nr 2/FEPD/4823/2024/I/EFRR/011/121. Niniejsza pożyczka została
              sfinansowana ze środków pochodzących z Funduszu Pożyczkowego utworzonego między innymi ze środków Programu
              Fundusze Europejskie dla Podlaskiego 2021-2027 oraz ze środków stanowiących krajowe współfinansowanie,
              zgodnie z Umową nr FEPD.PFP-IZ.00-0001/23-00 o finansowaniu Projektu pn. „Instrumenty Finansowe dla
              Podlaskiego 2021-2027” w ramach Fundusze Europejskie dla Podlaskiego 2021-2027, Priorytetu FEPD.01 Badania
              i Innowacje, Działania FEPD.01.03 Pożyczki na cyfryzację (nr FEPD.01.03-IZ.00-0001/23-00) <br />
              <strong>Opis i zadania projektu:</strong> Nadrzędnym celem projektu jest podniesienie oraz wzmocnienie
              trwałego wzrostu konkurencyjności firmy na rynku poprzez podniesienie poziomu cyfryzacji świadczonych
              przez nią usług poprzez zakup innowacyjnych, niezwykle dokładnych, oszczędnych i przyjaznych środowisku
              naturalnemu 2 szt. niwelatorów. Urządzenia te znajdą zastosowanie przy prowadzonych robotach drogowych
              przy precyzyjnym wyznaczaniu profilu podłużnego i poprzecznego drogi. Z projektu korzystać będą
              pracownicy, uczestniczący w procesach świadczenia usług w/w zestawem maszyn i urządzeń budowlanych oraz
              osoby zarządzające świadczeniem usług w naszej firmie, a docelowo, z tak wypracowanych rozwiązań
              technologicznych skorzystają wszyscy klienci spółki. Efektem projektu będzie realizacja zleconych prac
              przy budowie dróg z wykorzystaniem w/w niwelatorów o wysokiej wydajności i precyzji. Usługi wykonywane za
              pomocą tego zestawu maszyn i urządzeń budowlanych to inwestycja o charakterze innowacyjnym znacząco
              podnoszącym poziom zaawansowania cyfrowego przedsiębiorstwa, która przyniesie szereg korzyści w postaci
              zwiększenia wydajności, oszczędności czasu i kosztów, poprawy jakości wykonywanych prac ziemnych oraz
              bezpieczeństwa i komfortu pracy. Powyższy zakup udoskonali proces świadczenia usług przez firmę MP-TECH
              Piotr Mętel, a zakupione niwelatory wprowadzą polepszony sposób świadczenia usług
              <br />
              <strong>#FunduszeEuropejskie</strong>
              <br />
              <br />
              Wartość projektu: <strong>260 000,00 PLN</strong> <br />
              Wysokość wkładu z Funduszy Europejskich: <strong>64 341,27 PLN</strong>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Projects;
